<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  data () {
    return {
      locale: zhCN
    }
  }
};
</script>

<style lang="scss">
  @import './common/common';
  #app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  // background: rgb(248,248,248);
  background: #fff;
}
/*(1)清除默认样式*/
html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img,input{ margin:0; padding:0; }
fieldset, img,input,button { border:0 none; padding:0;margin:0;outline-style:none; }   /*去掉input等聚焦时的蓝色边框*/
ul,li,ol{ list-style:none; }
select, input { vertical-align:middle;}
textarea { resize:none; } /*防止拖动*/
img {border:0; vertical-align:middle; }
/*  去掉图片低测默认的3像素空白缝隙，或者用display：block也可以*/
table { border-collapse:collapse; }
a {text-decoration:none; }

/*2.添加公共样式*/
/*body {
    font:12px Arial,Verdana,"\5b8b\4f53";
    color:#666;
    background:#fff;
}*/
/*清除浮动（不管）*/
.clearfix:before,.clearfix:after {  /*清楚浮动*/
    content:"";
    display:table;
}
.clearfix:after{clear:both;}
.clearfix{
    *zoom:1;/*IE/7/6*/
}
h1,h2,h3,h4,h5,h6 {font-weight:normal;font-size:1em;}  /*设置h标签的大小，设置跟父亲一样大的字体font-size:100%;*/
s,i,em{font-style:normal;text-decoration:none;}


/*公共类*/
.con {  /*内容、版心 提取 */
    width: 1200px;
    margin:0 auto;
}
.fl {
    float:left;
}
.fr {
    float:right;
}
.ac {
    text-align:center;
}
.hide {
    display:none;
}
.f12{ font-size: 12px;}
.f14{ font-size: 14px;}
.f16{ font-size: 16px;}

.el-dialog__header{
  background-color: $green;
  padding: 10px 20px 10px;
  .el-dialog__headerbtn{
    top: 11px;
  }
  .el-dialog__title{
    font-size: $largeFont;
    color: white;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: white;
    font-size: 24px;
  }
}
  .el-step__description{
    padding-right: 0;
  }

  .el-button--primary{
    color: #fff;
    background-color: $sBlue;
    border-color: $sBlue;
    &:hover,&:focus{
      background-color:$blue;
      border-color:$blue
    }
  }
  .el-button--success{
    color: #fff;
    background-color: $green;
    border-color: $green;
    &:hover,&:focus{
      background-color:$sGreen;
      border-color:$sGreen
    }
  }
  .el-button--warning{
    color: #fff;
    background-color: $sOrange;
    border-color: $sOrange;
    &:hover,&:focus{
      background-color:$orange;
      border-color:$orange
    }
  }
  .el-button{
    /*padding: 12px 25px;*/
  }
  .messageZindex {
    z-index:3000 !important;
  }

/**
动画样式
*/
  .slide-fade-enter-active {
    transition: all 0.5s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-10px);
    opacity: 0;
  }
  .el-rate__icon{
    font-size: 16px;
    margin-right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue